import { FuelTypeEnum } from './AolEnums';

export class FuelRobPerTank {
    tankId: number;
    previousRobInMt: number;
    previousRobInM3?: number;
    robInMt: number;
    robInM3?: number;
    robDifferenceInMt: number;
    bunkeringInMt?: number;
    bunkeringInM3?: number;
    litreWeight?: number;
    sulphurPercent?: number;
    fuelType: FuelTypeEnum;

    tankName?: string;
    tankVolume?: number;

    constructor(
        tankId: number,
        previousRobInMt: number,
        robInMt: number,
        robDifferenceInMt: number,
        fuelType: FuelTypeEnum,
        bunkeringInMt?: number,
        litreWeight?: number,
        sulphurPercent?: number
    ) {
        this.tankId = tankId;
        this.previousRobInMt = previousRobInMt;
        this.robInMt = robInMt;
        this.robDifferenceInMt = robDifferenceInMt;
        this.bunkeringInMt = bunkeringInMt;
        this.litreWeight = litreWeight;
        this.sulphurPercent = sulphurPercent;
        this.fuelType = fuelType;
    }
}
